/**
 * 安全地从 localStorage 解析 JSON
 * @param {string} key - localStorage 的键名
 * @param {any} defaultValue - 如果解析失败或不存在时的默认值
 * @returns {any} 解析后的值或默认值
 */
export function safeParseLocalStorage(key, defaultValue = null) {
  try {
    const value = localStorage.getItem(key);
    if (value === null || value === undefined) {
      console.warn(`localStorage.${key} 不存在，使用默认值`);
      return defaultValue;
    }
    return JSON.parse(value);
  } catch (e) {
    console.error(`解析 localStorage.${key} 失败:`, e);
    return defaultValue;
  }
}

/**
 * 安全地获取用户角色
 * @returns {Array} 用户角色数组
 */
export function getSafeUserRoles() {
  return safeParseLocalStorage('roles', [{ label: 'initial_role', weight: 0 }]);
}

/**
 * 安全地获取用户信息
 * @returns {Object} 用户信息对象
 */
export function getSafeUserInfo() {
  return safeParseLocalStorage('User', {});
}

/**
 * 安全地获取屏幕数据
 * @returns {Object} 屏幕数据对象
 */
export function getSafeScreenData() {
  return safeParseLocalStorage('screenData', null);
}

/**
 * 安全地设置 localStorage 项
 * @param {string} key - localStorage 的键名
 * @param {any} value - 要存储的值
 */
export function safeSetLocalStorage(key, value) {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (e) {
    console.error(`设置 localStorage.${key} 失败:`, e);
  }
}
